import dayjs from "dayjs";

const store = (key, data) =>
  localStorage.setItem(key, encrypt(stringify(data)));
const encrypt = (data) => btoa(data);
const stringify = (data) => JSON.stringify(data);

const useLocalStorage = () => {
  return {
    storeToken: (token) => {
      store("jwt", token);
    },
    getAccessToken: () => {
      const jwt = localStorage.getItem("jwt");
      if (jwt) {
        return JSON.parse(atob(jwt)).accessToken;
      } else {
        return null;
      }
    },
    getTokenExpirationDate: () => {
      const jwt = localStorage.getItem("jwt");
      if (jwt) {
        return JSON.parse(atob(jwt)).expirationDate;
      } else {
        return null;
      }
    },
    storeUser: (user) => store("user", user),
    getUser: () => {
      const user = localStorage.getItem("user");
      if (user) {
        return JSON.parse(atob(user));
      } else {
        return null;
      }
    },
    clear: () => localStorage.clear(),
  };
};

export default useLocalStorage;
